import React, { useState } from "react";
import DonutChart from "../../../../../../_components/chart/DonutChart";
import RequestOrPaidInnerValue from "./RequestOrPaidInnerValue";
import { Menu, MenuItem } from "@mui/material";
import moment from "moment";

export default function MetricsCard(props) {
  const total = Number(props.requestedValue ?? 0) + Number(props.paidInValue ?? 0);
  let percentage = ((total - Number(props.requestedValue ?? 0)) / Number(props.requestedValue ?? 0)) * 100 || 0;
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const filterHandler = (filter) => {
    props.onFilter(filter);
  };

  const filterMetric = (metric) => {
    switch (metric) {
      case 0: //last 30 days
        {
          const input = {
            from: moment().subtract(30, "days").toISOString(),
            to: moment().subtract().toISOString(),
          };
          filterHandler(input);
          console.log(input);
        }
        break;
      case 1: //last quarter
        {
          const input = {
            from: moment().subtract(1, "quarter").toISOString(),
            to: moment().subtract().toISOString(),
          };
          filterHandler(input);
          console.log(input);
        }
        break;
      case 2: //last year
        {
          const input = {
            from: moment().subtract(1, "year").toISOString(),
            to: moment().subtract().toISOString(),
          };
          filterHandler(input);
          console.log(input);
        }
        break;
      case 3: //year to date
        {
          const input = {
            from: moment().startOf("year").toISOString(),
            to: moment().subtract().toISOString(),
          };
          filterHandler(input);
          console.log(input);
        }
        break;

      default:
        break;
    }
    setAnchorEl(null);
  };

  return (
    <div className="card tw-w-fit  tw-bg-white tw-p-4">
      <div className="tw-flex tw-items-center tw-justify-between">
        <p className="tw-text-base tw-font-medium tw-capitalize tw-text-black">
          {props.title}
        </p>

        <button
          aria-controls={open ? "basic-menu" : undefined}
          aria-haspopup="true"
          aria-expanded={open ? "true" : undefined}
          onClick={handleClick}
        >
          <svg
            width="19"
            height="19"
            viewBox="0 0 19 19"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <mask
              id="mask0_1313_7008"
              style={{ maskType: "alpha" }}
              maskUnits="userSpaceOnUse"
              x="0"
              y="0"
              width="19"
              height="19"
            >
              <rect
                x="0.285156"
                y="0.753906"
                width="17.8667"
                height="17.8667"
                fill="#D9D9D9"
              />
            </mask>
            <g mask="url(#mask0_1313_7008)">
              <path
                d="M4.75061 11.176C4.34116 11.176 3.99065 11.0302 3.69908 10.7387C3.40751 10.4471 3.26172 10.0966 3.26172 9.68713C3.26172 9.27769 3.40751 8.92718 3.69908 8.6356C3.99065 8.34403 4.34116 8.19824 4.75061 8.19824C5.16005 8.19824 5.51056 8.34403 5.80214 8.6356C6.09371 8.92718 6.2395 9.27769 6.2395 9.68713C6.2395 10.0966 6.09371 10.4471 5.80214 10.7387C5.51056 11.0302 5.16005 11.176 4.75061 11.176ZM9.21727 11.176C8.80783 11.176 8.45732 11.0302 8.16575 10.7387C7.87417 10.4471 7.72839 10.0966 7.72839 9.68713C7.72839 9.27769 7.87417 8.92718 8.16575 8.6356C8.45732 8.34403 8.80783 8.19824 9.21727 8.19824C9.62672 8.19824 9.97723 8.34403 10.2688 8.6356C10.5604 8.92718 10.7062 9.27769 10.7062 9.68713C10.7062 10.0966 10.5604 10.4471 10.2688 10.7387C9.97723 11.0302 9.62672 11.176 9.21727 11.176ZM13.6839 11.176C13.2745 11.176 12.924 11.0302 12.6324 10.7387C12.3408 10.4471 12.1951 10.0966 12.1951 9.68713C12.1951 9.27769 12.3408 8.92718 12.6324 8.6356C12.924 8.34403 13.2745 8.19824 13.6839 8.19824C14.0934 8.19824 14.4439 8.34403 14.7355 8.6356C15.027 8.92718 15.1728 9.27769 15.1728 9.68713C15.1728 10.0966 15.027 10.4471 14.7355 10.7387C14.4439 11.0302 14.0934 11.176 13.6839 11.176Z"
                fill="#666666"
              />
            </g>
          </svg>
        </button>
        <Menu
          id="basic-menu"
          anchorEl={anchorEl}
          open={open}
          onClose={handleClose}
          MenuListProps={{
            "aria-labelledby": "basic-button",
          }}
        >
          <MenuItem onClick={() => filterMetric(0)}>Last 30 days</MenuItem>
          <MenuItem onClick={() => filterMetric(1)}>Last quarter</MenuItem>
          <MenuItem onClick={() => filterMetric(2)}>Last year</MenuItem>
          <MenuItem onClick={() => filterMetric(3)}>Year to date</MenuItem>
        </Menu>
      </div>

      <div className="tw-my-3 tw-flex tw-items-center tw-gap-x-8 xl:tw-gap-x-10 2xl:tw-gap-x-16 ">
        <RequestOrPaidInnerValue
          value={props.requestedValue}
          additionalData={props.requestedAdditionalData}
          type={props.requestedType}
        />
        <RequestOrPaidInnerValue
          value={props.paidInValue}
          additionalData={props.paidInVdditionalData}
          type={props.paidInVype}
        />

        {/* chart doughtnut */}
        <div className="d-inline-block position-relative donut-chart-sale">
          <DonutChart value={percentage} backgroundColor2={"#2e7d32"} />
          <small className="tw-text-[#37D159]">{percentage.toFixed()}%</small>
          <span className="circle tw-bg-[#D5F5DC]  " />
        </div>
      </div>
    </div>
  );
}
